import { NewSupplierGetters } from './new-supplier.keys';
import format from 'date-fns/format';

export const getInitialState = () => {
  return {
    newSupplier: {
      created_at: format(new Date(), 'YYYY-MM-DD'),
      name: '',
      is_active: true,
      hst: '',
      qst: '',
      gst: '',
      address: [],
      client_name: '',
      address_id: null
    }
  };
};

export const newSupplierStore = {
  state: getInitialState,
  getters: {
    [NewSupplierGetters.NewSupplier]: state => {
      return state.newSupplier;
    }
  }
};
